export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (...rest) => {
    console.error('vue:error', ...rest);
  });

  nuxtApp.hook('app:error', (...rest) => {
    console.error('app:error', ...rest);
  });
});
